import type { RateBarTone } from "web_myplann/Shared/Types/RateBarTone";

export const getRateBarTone = (
	isEmphasized: boolean,
	isSubtle: boolean,
): RateBarTone => {
	if (isEmphasized) {
		return "emphasized";
	}

	return isSubtle ? "subtle" : "default";
};
